import Casal from "./Casal";

class Alergen {
    constructor(
        public id: number = 0,
        public key: number = 0,
        public num: number = 0,
        public nom: string = "",
        public label: string = "",
        public comentaris: string = "",
    ) {}
}

export default Alergen;
